import { getApplicationUrl } from "@/config";
import router from "@/router";
import Request from "@/ts/Request";
import axios from "axios";
import moment from "moment";
import LoginModal from "shared-components/LoginModal";
import { Component, Vue } from "vue-property-decorator";

declare let window: any;
declare let calendar: any;
@Component
export default class Util extends Vue {
  private static listener: EventListener;

  static setBackButtonBehavior(listener: EventListener) {
    if (Util.listener)
      document.removeEventListener("backbutton", Util.listener);
    Util.listener = listener;
    document.addEventListener("backbutton", Util.listener, false);
  }

  static getBackButtonBehavior() {
    return Util.listener;
  }

  static removeBackButtonBehavior() {
    document.removeEventListener("backbutton", Util.listener);
  }

  static isEmpty(obj: any) {
    for (const property in obj) {
      if (obj.hasOwnProperty(property)) return false;
    }
    return true;
  }

  static addNpfMask(npf: string) {
    npf = Util.removeMasks(npf);
    const len: number = npf.length;
    if (len > 3) {
      npf = npf[0] + " " + npf.substring(1, len - 1) + "-" + npf[len - 1];
    }
    return npf;
  }

  static removeMasks(npf: string) {
    return npf.replace(/-/g, "").replace(/\./g, "").replace(/ /g, "");
  }

  static addCpfMask(cpf: string) {
    cpf = Util.removeMasks(cpf);
    const len: number = cpf.length;
    if (len == 11) {
      cpf =
        cpf.substring(0, 3) +
        "." +
        cpf.substring(3, 6) +
        "." +
        cpf.substring(6, 9) +
        "-" +
        cpf.substring(9, 11);
    }
    return cpf;
  }

  static onNewFCMToken(fcmToken: string) {
    const req: Request = new Request();
    req.route = "updateFCMToken";
    req.body = {
      NRORG: sessionStorage.getItem("NRORG"),
      TOKEN: sessionStorage.getItem("TOKEN"),
      USER_ID: sessionStorage.getItem("USER_ID"),
      FCM_TOKEN: fcmToken,
    };
    req.callbackSuccess = function (response: any) {};
    req.callbackError = function (error: any) {};
    req.showLoader = false;
    req.send();
  }

  static getUserData(callback?: Function) {
    const self = this;
    const req = new Request();
    req.body = {
      USER_ID: sessionStorage.getItem("USER_ID") || "",
      NRORG: sessionStorage.getItem("NRORG"),
      TOKEN: sessionStorage.getItem("TOKEN") || "",
      USER_TYPE_ID: 1,
      TOKEN_EXT: sessionStorage.getItem("TOKEN_EXT") || "",
    };
    req.route = "getUserData";
    req.callbackSuccess = function (response: any) {
      const now: any = moment();
      sessionStorage.setItem("USER_DATA", JSON.stringify(response.user));
      sessionStorage.setItem("USER_NAME", response.user.FIRST_NAME);
      sessionStorage.setItem("LAST_GET_USER_DATA", now);
      if (callback) callback(response);
    };
    req.callbackError = function (error: any) {
      console.log(error);
    };
    req.send();
  }

  static getUserReports(callback: any) {
    const req = new Request();
    req.body = {
      NRORG: sessionStorage.getItem("NRORG"),
      USER_ID: sessionStorage.getItem("USER_ID"),
      TOKEN: sessionStorage.getItem("TOKEN"),
    };
    req.route = "getReportsByUser";
    req.callbackSuccess = function (response: any) {
      if (callback) callback(response.reports);
      const now: any = moment();
      sessionStorage.setItem("LAST_GET_REPORTS", now);
    };
    req.callbackError = function (error: any) {
      console.log(error);
    };
    req.showLoader = true;
    req.send();
  }

  static getUserNotifications(callback: any) {
    const req = new Request();
    req.body = {
      NRORG: sessionStorage.getItem("NRORG"),
      USER_ID: sessionStorage.getItem("USER_ID"),
      TOKEN: sessionStorage.getItem("TOKEN"),
      TIMEZONE: Util.getTimezone(),
    };
    req.route = "getNotificationsByUser";
    req.callbackSuccess = function (response: any) {
      if (callback) callback(response.notifications);
      const now: any = moment();
      sessionStorage.setItem("LAST_GET_NOTIFICATIONS", now);
    };
    req.callbackError = function (error: any) {
      console.log(error);
    };
    req.showLoader = true;
    req.send();
  }

  static getImgUrl(imageName: string, extension = ".svg") {
    const images = require.context("../assets/", false);
    return images("./" + imageName + extension);
  }

  static capitalize(text: string) {
    return text
      ? text
          .split(" ")
          .map((x) =>
            x ? x[0].toUpperCase() + x.substring(1).toLowerCase() : ""
          )
          .join(" ")
      : "";
  }

  static closeKeyboard() {
    $("input").blur();
  }

  checkUpdateReadyToInstall() {
    const now: any = moment();
    const lastResume: any = sessionStorage.getItem("LAST_RESUME");
    const duration = Number(
      moment.duration(moment().diff(lastResume, "hours"))
    );
    const actualRoute = String(router.currentRoute.name);
    const homeLayout = Util.verifyRouteHome();
    const restartEnabledRoutes = [
      '"' + homeLayout + '"',
      "Carteira",
      "PedidosRealizados",
      "Lojas",
    ];

    if (
      duration >= 6 &&
      sessionStorage.getItem("UPDATE_INSTALLED") === "true" &&
      restartEnabledRoutes.includes(actualRoute)
    ) {
      const _window: any = window;
      sessionStorage.removeItem("UPDATE_INSTALLED");
      sessionStorage.setItem("LAST_RESUME", now.toISOString());
      _window.codePush.restartApplication();
    }
    sessionStorage.setItem("LAST_RESUME", now.toISOString());
  }

  static syncCalendarSystem(saveCalendar: any) {
    saveCalendar.details += "\n\nCriado por App Minas by Zeedhi";

    window.plugins.calendar.createEventInteractivelyWithOptions(
      saveCalendar.nameEvt,
      saveCalendar.location,
      saveCalendar.details,
      saveCalendar.initialDate,
      saveCalendar.finalDate,
      {},
      (success: any) => {
        // sucesso
        console.log(success);
      },
      (error: any) => {
        //erro
        console.log(error);
      }
    );
  }

  static checkLocalization() {
    let latitude = 0;
    let longitude = 0;
    navigator.geolocation.getCurrentPosition(
      (location: any) => {
        latitude = location.coords.latitude;
        longitude = location.coords.longitude;
        sessionStorage.setItem("LATITUDE", JSON.stringify(latitude));
        sessionStorage.setItem("LONGITUDE", JSON.stringify(longitude));
      },
      console.error,
      { timeout: 10000 }
    );
  }

  static ajustWindow() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    // We listen to the resize event
    window.addEventListener("resize", () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });
  }

  static logOff() {
    try {
      const req = new Request();
      req.body = {
        NRORG: sessionStorage.getItem("NRORG"),
        TOKEN_EXT: sessionStorage.getItem("TOKEN_EXT") || "",
      };
      req.route = "logout";
      req.visibilityOptions = { success: false, error: false, loading: true };
      req.callbackSuccess = function () {};
      req.callbackError = function () {};
      req.loadingMessage = "Saindo da sua conta...";
      req.blockTouchEvents = true;
      req.send();
    } catch (e) {
      console.log(e);
    }

    try {
      sessionStorage.setItem("CAME_FROM_LOGOUT", "true");
      sessionStorage.setItem("CAME_FROM_FORGOT_PASSWORD", "true");
      sessionStorage.removeItem("USER_ID");
      sessionStorage.removeItem("CONSUMER_REF");
      sessionStorage.removeItem("CONSUMER_CODE");
      sessionStorage.removeItem("CLIENT_CODE");
      sessionStorage.removeItem("USER_DATA");
      sessionStorage.removeItem("USER_DATE");
      sessionStorage.removeItem("USER_NAME");
      sessionStorage.removeItem("TOKEN");
      sessionStorage.removeItem("REFRESH_TOKEN");
      sessionStorage.removeItem("TOKEN_EXT");
      sessionStorage.removeItem("ID_EXT");
      sessionStorage.removeItem("KEY_EXT");
      sessionStorage.removeItem("TOTP");
      sessionStorage.removeItem("GET_MODALITY_FROM_LS");
      sessionStorage.removeItem("GET_CLASS_FROM_LS");
      sessionStorage.removeItem("SKIP_PREFERENCES");
      sessionStorage.removeItem("ANALYTICS_KEY");
      sessionStorage.removeItem("BOLETOS");
      sessionStorage.removeItem("METHOD_SELECTED");
      sessionStorage.setItem("FULL_METHOD_SELECTED", "{}");

      const LogOff: any = LoginModal;
      LogOff.externalSignOut();

      setTimeout(() => router.go(0), 5000);
    } catch (e) {
      console.log(e);
    }
  }

  static eraseUserInformation() {
    sessionStorage.setItem("USER_ID", "");
    sessionStorage.setItem("USER_DATA", "");
    sessionStorage.setItem("TOTP", "");
    sessionStorage.setItem("USER_DATE", "");
    sessionStorage.setItem("EVENTS", "");
    sessionStorage.setItem("ENTERED_ORDERS_FROM", "");
    sessionStorage.setItem("ORG_FIELDS", "");
    sessionStorage.setItem("stores", "");
    sessionStorage.setItem("USER_TICKETS", "");
    sessionStorage.setItem("STRUCTURES", "");
    sessionStorage.setItem("DADOS_USUARIOS", "");
    sessionStorage.setItem("LAST_ROUTE", "");
    sessionStorage.setItem("CALENDAR", "");
    sessionStorage.setItem("HAS_NOTIFICATION", "");
    sessionStorage.setItem("FULL_METHOD_SELECTED", "");
    sessionStorage.setItem("FILTERED_TICKET_EVENTS", "");
    sessionStorage.setItem("STRUCTURE_ID", "");
    sessionStorage.setItem("CARDS_PARENT", "");
    sessionStorage.setItem("CREDIT_CARDS", "");
    sessionStorage.setItem("NEWS", "");
    sessionStorage.setItem("LAST_GET_USER_DATA", "");
    sessionStorage.setItem("METHOD_SELECTED", "");
    sessionStorage.setItem("FILTERED_TICKET_EVENTS", "");
    sessionStorage.setItem("QR_FROM", "");
    sessionStorage.setItem("WALLET", "");
    sessionStorage.setItem("CLOSE_EVENTS", "");
    sessionStorage.setItem("structureId", "");
    sessionStorage.setItem("deliversToTable", "");
    sessionStorage.setItem("MAIN_CARTAO", "");
    sessionStorage.setItem("SHOW_FILTERED_EVENTS", "");
    sessionStorage.setItem("USER_DEPENDENTS", "");
    sessionStorage.setItem("CURRENT_ORDERS", "");
    sessionStorage.setItem("LAST_DAY_ESCOLHER_UNIDADE", "");
    sessionStorage.setItem("deliverToBalcony", "");
    sessionStorage.setItem("STRUCTURES_QR", "");
    sessionStorage.setItem("LAST_GET_HOME", "");
    sessionStorage.setItem("BOLETOS", "");
    sessionStorage.setItem("USE_CURRENT_LOCATION", "");
    sessionStorage.setItem("PROVISORY_ADDRESS", "");
    sessionStorage.setItem("NO_ADDRESS_MODAL", "");
  }

  static cancelLogoff() {
    this.setBackButtonBehavior(function () {
      $(".sidenav").sidenav("close");
    });
  }

  static goToLogin() {
    const useIntegration =
      sessionStorage.getItem("USE_INTEGRATION") === "true" ? true : false;
    if (useIntegration) {
      router.push("LoginApp");
    } else {
      router.push("Login");
    }
  }

  static getUseIntegration() {
    const bodyObj = {
      USER_ID: 1,
    };

    const req = new Request();
    req.body = {
      requestType: "Row",
      row: Object.assign(bodyObj),
    };
    req.showLoader = false;

    return axios.post(Request.urlBase + "getUseIntegration", req.body);
  }

  static chooseHome(homeLayout: any) {
    let route: string;

    switch (homeLayout) {
      case "app":
        route = "HomeApp";
        break;
      case "release":
        route = "HomeRelease";
        break;
      case "Lojas":
        route = "HomeLojas";
        break;
      default:
        route = "HomeFeed";
        break;
    }
    return route;
  }

  static verifyRouteHome() {
    const organizationData = JSON.parse(
      sessionStorage.getItem("ORGANIZATION_DATA") || "{}"
    );

    const homeLayout =
      organizationData &&
      organizationData.CONFIGURATIONS &&
      organizationData.CONFIGURATIONS.APP_LAYOUT_CONFIG &&
      organizationData.CONFIGURATIONS.APP_LAYOUT_CONFIG.homeLayout
        ? organizationData.CONFIGURATIONS.APP_LAYOUT_CONFIG.homeLayout
        : "feed";

    const result: any = Util.chooseHome(homeLayout);
    sessionStorage.setItem("HOME_LAYOUT", result);
    return result;
  }

  static getTimezone() {
    return moment(new Date()).format("Z");
  }

  static async decodeStoreNamePathRoute(decodePath: string, nrorg: number) {
    const stores: any = await this.getStores(nrorg);
    if (!stores) {
      // Lojas não encontradas
      return false;
    }

    const normalize = (str: string) =>
      decodeURIComponent(str)
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, "")
        .toLowerCase();
    const normalizedStoreName = normalize(decodePath);
    const store = stores.find((store: any) => {
      return normalize(store.name) == normalizedStoreName;
    });

    if (!store) {
      // Loja não encontrada
      console.log("Loja não encontrada");
      return false;
    }
    sessionStorage.removeItem("storeId");
    sessionStorage.removeItem("ITEMS");
    sessionStorage.removeItem("CURRENT_ORDER");
    sessionStorage.setItem("storeId", JSON.stringify(store.id));
    sessionStorage.setItem("CAME_FROM_QRCODE", JSON.stringify(true));
    sessionStorage.setItem("SHOW_BUTTONS", JSON.stringify(true));
    if (sessionStorage.getItem("CAME_FROM_RELEASE") != "true") {
      sessionStorage.setItem("SHOW_BACKBUTTON", JSON.stringify(false));
      sessionStorage.setItem("SHOW_ORDERBUTTON", JSON.stringify(true));
    }

    this.getIfStoreHasAnySubmenu(Number(store.id)).then((response: any) => {
      if (response) {
        router.push({
          name: "Produtos",
          params: { idStore: store.id },
        });
      } else {
        router.push({
          name: "ListaDeProdutos",
          params: { idStore: store.id },
        });
      }
    });

    return true;
  }

  static async decodePathRoute(decodePath: string) {
    const routeDecoded = decodePath.split("/");
    if (!sessionStorage.getItem("BLOCK_BACK")) {
      sessionStorage.removeItem("STORE");
    }
    sessionStorage.removeItem("storeId");
    sessionStorage.removeItem("ITEMS");
    sessionStorage.removeItem("CURRENT_ORDER");
    sessionStorage.setItem("storeId", JSON.stringify(routeDecoded[1]));
    if (sessionStorage.getItem("CAME_FROM_RELEASE") != "true") {
      sessionStorage.setItem("SHOW_BACKBUTTON", JSON.stringify(false));
      sessionStorage.setItem("SHOW_ORDERBUTTON", JSON.stringify(true));
    }

    let integrationCommands = null;
    if (routeDecoded.length !== 3) {
      integrationCommands = await this.getIntegrationCommands(
        routeDecoded[2],
        Number(routeDecoded[1])
      );
    }

    if (integrationCommands) {
      if (routeDecoded.length !== 3) {
        sessionStorage.setItem(
          "STRUCTURE_ID",
          JSON.stringify(Number(routeDecoded[2]))
        );
        sessionStorage.setItem("CAME_FROM_QRCODE", JSON.stringify(true));
        sessionStorage.setItem("SHOW_BUTTONS", routeDecoded[3]);
        if (routeDecoded[3] == "false") {
          //cardápio digital
          router.push({
            name: "ListaDeProdutos",
            params: { idStore: routeDecoded[1], idTable: routeDecoded[2] },
            query: { digitalMenu: "true" },
          });
        } else {
          router.push({
            name: "ListaDeProdutos",
            params: { idStore: routeDecoded[1], idTable: routeDecoded[2] },
          });
        }
      }
    } else {
      this.getIfStoreHasAnySubmenu(Number(routeDecoded[1])).then(
        (response: any) => {
          if (response) {
            if (routeDecoded.length == 3 && routeDecoded[2] !== "mercAut") {
              sessionStorage.setItem("SHOW_BUTTONS", routeDecoded[2]);
              if (routeDecoded[2] == "false") {
                //cardápio digital
                router.push({
                  name: "Produtos",
                  params: { idStore: routeDecoded[1] },
                  query: { digitalMenu: "true" },
                });
              } else {
                router.push({
                  name: "Produtos",
                  params: { idStore: routeDecoded[1] },
                });
              }
            } else if (
              routeDecoded.length == 3 &&
              routeDecoded[2] == "mercAut"
            ) {
              sessionStorage.setItem("CAME_FROM_QRCODE", JSON.stringify(true));
              sessionStorage.setItem("SHOW_BUTTONS", JSON.stringify(true));
              router.push({
                name: "BarCodeProduct",
                params: { idStore: routeDecoded[1] },
              });
            } else if (
              routeDecoded.length == 4 &&
              routeDecoded[2] != "mercAut"
            ) {
              //mesa
              sessionStorage.setItem("CAME_FROM_QRCODE", JSON.stringify(true));
              sessionStorage.setItem("SHOW_BUTTONS", routeDecoded[3]);
              router.push({
                name: "Produtos",
                params: { idStore: routeDecoded[1], idTable: routeDecoded[2] },
              });
            } else {
              sessionStorage.setItem("CAME_FROM_QRCODE", JSON.stringify(true));
              sessionStorage.setItem("SHOW_BUTTONS", routeDecoded[3]);
              if (routeDecoded[3] == "false") {
                //cardápio digital
                router.push({
                  name: "Produtos",
                  params: {
                    idStore: routeDecoded[1],
                    idTable: routeDecoded[2],
                  },
                  query: { digitalMenu: "true" },
                });
              } else {
                router.push({
                  name: "Produtos",
                  params: {
                    idStore: routeDecoded[1],
                    idTable: routeDecoded[2],
                  },
                });
              }
            }
          } else {
            if (routeDecoded.length == 3 && routeDecoded[2] != "mercAut") {
              sessionStorage.setItem("SHOW_BUTTONS", routeDecoded[2]);
              if (routeDecoded[2] == "false") {
                //cardápio digital
                router.push({
                  name: "ListaDeProdutos",
                  params: { idStore: routeDecoded[1] },
                  query: { digitalMenu: "true" },
                });
              } else {
                router.push({
                  name: "ListaDeProdutos",
                  params: { idStore: routeDecoded[1] },
                });
              }
            } else if (
              routeDecoded.length == 3 &&
              routeDecoded[2] == "mercAut"
            ) {
              sessionStorage.setItem("CAME_FROM_QRCODE", JSON.stringify(true));
              sessionStorage.setItem("SHOW_BUTTONS", JSON.stringify(true));
              router.push({
                name: "BarCodeProduct",
                params: { idStore: routeDecoded[1] },
              });
            } else if (
              routeDecoded.length == 4 &&
              routeDecoded[2] != "mercAut"
            ) {
              //mesa
              routeDecoded[0] = "ListaDeProdutos";
              sessionStorage.setItem("SHOW_BUTTONS", routeDecoded[3]);
              router.push({
                name: "ListaDeProdutos",
                params: { idStore: routeDecoded[1], idTable: routeDecoded[2] },
              });
            } else {
              sessionStorage.setItem("CAME_FROM_QRCODE", JSON.stringify(true));
              sessionStorage.setItem("SHOW_BUTTONS", routeDecoded[3]);
              if (routeDecoded[3] == "false") {
                //cardápio digital
                router.push({
                  name: "Produtos",
                  params: {
                    idStore: routeDecoded[1],
                    idTable: routeDecoded[2],
                  },
                  query: { digitalMenu: "true" },
                });
              } else {
                router.push({
                  name: "Produtos",
                  params: {
                    idStore: routeDecoded[1],
                    idTable: routeDecoded[2],
                  },
                });
              }
            }
          }
        }
      );
    }
  }

  static goProducts(path = "Produtos") {
    sessionStorage.setItem("loadStore", JSON.stringify(true));
    router.push(path);
  }

  static async getIfStoreHasAnySubmenu(storeId: number) {
    const request = new Request();
    request.route = `getIfStoreHasAnySubmenu?requestType=FilterData&STORE_ID=${storeId}`;
    request.showLoader = false;
    try {
      const response = await request.get();
      return response.ifStoreHasAnySubmenu.ifHasSubmenu;
    } catch (error) {
      console.error(error);
    }
  }

  static async getIntegrationCommands(structureId: any, storeId: number) {
    try {
      if (structureId) {
        const req = new Request();
        req.body = {
          NRORG: sessionStorage.getItem("NRORG"),
          STRUCTURE_ID: structureId,
          STORE_ID: storeId,
        };
        req.route = "getStructureById";
        const response = await req.send();
        sessionStorage.setItem(
          "currentStructure",
          JSON.stringify(response.structure)
        );
        return response.structure.integrationCommands;
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  static getStores(nrorg: number) {
    return new Promise((resolve: Function, reject: Function) => {
      try {
        const req = new Request();
        req.body = {
          NRORG: nrorg,
          STRUCTURE_ID: null,
          LATITUDE: null,
          LONGITUDE: null,
          DEVICE_TIME: null,
          URL: getApplicationUrl(),
        };
        req.route = "getStoresNearUser";
        req.callbackSuccess = (response: any) => {
          const stores = response.stores;
          resolve(stores);
        };
        req.callbackError = function (error: any) {
          reject(error);
        };
        req.blockTouchEvents = false;
        req.showLoader = false;
        req.send();
      } catch (e) {
        reject(e);
      }
    });
  }

  static getDeviceTime() {
    moment.locale("pt-br");
    const deviceTime: any = moment().format("LT");
    return deviceTime;
  }

  static getFidelityProgram() {
    const req = new Request();
    req.body = {
      USER_ID: sessionStorage.getItem("USER_ID") || "",
      NRORG: sessionStorage.getItem("NRORG"),
    };
    req.route = "getFidelityProgram";
    req.callbackSuccess = (response: any) => {
      if (response.getFidelityProgram.status) {
        sessionStorage.setItem("FIDELITY_PROGRAM", JSON.stringify(true));
        sessionStorage.setItem(
          "FIDELITY_PROGRAM_INFO",
          JSON.stringify(response.getFidelityProgram)
        );
      } else {
        sessionStorage.setItem("FIDELITY_PROGRAM", JSON.stringify(false));
      }
    };
    req.callbackError = (error: any) => {
      console.log(error);
    };
    req.showLoader = false;
    req.send();
  }

  static removeTableData() {
    if (sessionStorage.getItem("DELIVER_AT") === "T") {
      sessionStorage.removeItem("DELIVER_AT");
      sessionStorage.removeItem("currentStructure");
      sessionStorage.removeItem("IDTABLE");
      sessionStorage.removeItem("ENTERED_LER_QR");
      sessionStorage.removeItem("STRUCTURE_ID");
    }
  }
}
